export { SustainableDevelopmentGoals as default } from "@ecologi/react-components/src/SustainableDevelopmentGoals";
